import React, { useEffect, useState } from 'react'
import { GlobalTable, HeaderLine, Td, Th, Tr } from '../../../../components/styles/table-style'
import axios from 'axios'
import { useOutletContext } from 'react-router-dom'
import { ProductionOutletType } from '..'

interface Stage {
  id: number
  name: string
}

const StagesTable: React.FC = () => {
  const [ stages, setStages ] = useState<Stage[]>([])
  const { setTabIndex } = useOutletContext<ProductionOutletType>()

  useEffect(() => {
    setTabIndex(2)
  }, [])

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_PRODUCTION_FLOW_BASE_URL}/stages`)
      .then((response) => {
        if(response.data) setStages(response.data)
      })
      .catch((error) => {
        console.error(error)
      })
  }, [])
  
  return(
    <GlobalTable>
      <thead>
        <HeaderLine>
          <Th>Etapa</Th>
          <Th>Setor</Th>
          <Th>Máquinas</Th>
        </HeaderLine>
      </thead>
      <tbody>
        {stages.map((stage) => (
          <Tr key={stage.id}>
            <Td>{stage.name}</Td>
            <Td>Setor 1</Td>
            <Td>Maquina 1</Td>
          </Tr>
        ))}
      </tbody>
    </GlobalTable>
  )
}

export default StagesTable